"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var LastIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M9.46062427,16.0054419 C7.38746804,18.2024481 5.68179901,20 5.67025011,20 C5.65870122,20 5.28292732,19.6113347 4.83519683,19.1363008 L4.02114245,18.2726033 L6.97030854,15.1472299 L9.91947629,12.0218577 L6.95973814,8.88528264 L4,5.74870779 L4.82488055,4.87435398 C5.27856452,4.39345922 5.65907578,4 5.67046297,4 C5.69075068,4 13.2299995,11.9784844 13.2299995,11.999955 C13.2299995,12.0059661 11.5337805,13.8084356 9.46062427,16.0054419 Z" }),
        React.createElement("rect", { width: "2", height: "16", x: "16", y: "4", fill: "currentColor", fillRule: "nonzero" })))); };
exports.LastIcon = LastIcon;
